import React from "react";
import styles from "../../styles/Common.module.css";
import Head from "next/head";
const HoodiesSkeletonLoader = () => {
  const shimmerStyle = {
    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
    backgroundSize: '200% 100%',
    animation: 'shimmer 1.5s infinite',
  };

  const createHoodieSkeletonItems = (count) => {
    return Array.from({ length: count }, (_, index) => (
      <div key={index} className={styles.hoodie_item} style={{
        opacity: 0.2,
        marginBottom: '24px',
        padding: '12px',
        backgroundColor: '#2a2a2a',
        // borderRadius: '8px'
      }}>
        {/* Product Image */}
        <div style={{
          width: '100%',
          height: '200px',
          marginBottom: '12px',
          borderRadius: '6px',
          overflow: 'hidden'
        }}>
          <div
            style={{
              ...shimmerStyle,
              width: '100%',
              height: '100%',
              borderRadius: '6px'
            }}
          ></div>
        </div>

        {/* Product Title */}
        <div
          style={{
            ...shimmerStyle,
            width: '90%',
            height: '20px',
            borderRadius: '4px',
            marginBottom: '8px'
          }}
        ></div>

        {/* Price */}
        <div
          style={{
            ...shimmerStyle,
            width: '60%',
            height: '18px',
            borderRadius: '4px',
            marginBottom: '6px'
          }}
        ></div>

        {/* Printify Premium text */}
        <div
          style={{
            ...shimmerStyle,
            width: '70%',
            height: '16px',
            borderRadius: '4px',
            marginBottom: '6px'
          }}
        ></div>

        {/* Size/Color variants */}
        <div
          style={{
            ...shimmerStyle,
            width: '80%',
            height: '14px',
            borderRadius: '4px'
          }}
        ></div>
      </div>
    ));
  };

  return (
    <>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <style jsx>{`
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
      `}</style>

      <div style={{
        backgroundColor: '#1a1a1a',
        padding: '20px',
        borderRadius: '8px',
        marginTop: '32px'
      }}>

        {/* Products Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '16px',
          marginBottom: '20px'
        }}>
          {createHoodieSkeletonItems(5)}
        </div>
      </div>
    </>
  );
};

export default HoodiesSkeletonLoader;